import type { Prompt, PromptFolder } from ".";

export type EditableArtifactPrompts =
	| ArtifactFastEditPrompt
	| ArtifactResearchMoreEditPrompt
	| ArtifactResearchMoreReformulationPrompt
	| ArtifactWebReformulationPrompt
	| SearchQueriesGenerationPrompt
	| ArtifactWebEditPrompt;

/* eslint-disable @typescript-eslint/naming-convention */
export const editableArtifactPromptFolders = {
	"artifact-fast-edit": "editable-artifact",
	"artifact-research-more-edit": "editable-artifact",
	"artifact-research-more-reformulation": "editable-artifact",
	"artifact-web-edit": "editable-artifact",
	"artifact-web-reformulation": "editable-artifact",
	"search-queries-generation": "editable-artifact",
} as const satisfies Record<EditableArtifactPrompts["name"], PromptFolder>;
/* eslint-enable @typescript-eslint/naming-convention */

export interface ArtifactFastEditPrompt extends Prompt {
	name: "artifact-fast-edit";
	variables: {
		query: string;
		originalQuery: string;
		artifactContent: string;
		selectedText: string;
		selectedSections: string;
		selectedSectionContents: string;
	};
}

export interface ArtifactResearchMoreEditPrompt extends Prompt {
	name: "artifact-research-more-edit";
	variables: {
		query: string;
		originalQuery: string;
		artifactContent: string;
		selectedText: string;
		selectedSections: string;
		selectedSectionContents: string;
		documents: string;
	};
}

export interface ArtifactResearchMoreReformulationPrompt extends Prompt {
	name: "artifact-research-more-reformulation";
	variables: {
		query: string;
		originalQuery: string;
		artifactContent: string;
		selectedText: string;
		selectedSectionContents: string;
	};
}

export interface ArtifactWebEditPrompt extends Prompt {
	name: "artifact-web-edit";
	variables: {
		query: string;
		originalQuery: string;
		artifactContent: string;
		selectedText: string;
		selectedSections: string;
		selectedSectionContents: string;
		searchResults: string;
		language: string;
	};
}

export interface ArtifactWebReformulationPrompt extends Prompt {
	name: "artifact-web-reformulation";
	variables: {
		query: string;
		originalQuery: string;
		artifactContent: string;
		selectedText: string;
		selectedSectionContents: string;
	};
}

export interface SearchQueriesGenerationPrompt extends Prompt {
	name: "search-queries-generation";
	variables: {
		language: string;
		query: string;
		date: string;
		conversationState: string;
		chatHistory: string;
	};
}
